/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/v1/billing/office/plan/minimal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Creates a minimal plan */
        post: {
            parameters: {
                query?: never;
                header?: {
                    /** @description Cookie */
                    Cookie?: string;
                };
                path?: never;
                cookie?: never;
            };
            /** @description Create plan minimal request */
            requestBody: {
                content: {
                    "application/json": components["schemas"]["dtos.CreatePlanMinimalRequestBody"];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        "dtos.CreatePlanMinimalRequestBody": {
            amount: number;
            currency: components["schemas"]["enums.Currency"];
            limits: components["schemas"]["dtos.PlanLimit"][];
            name: string;
            period: components["schemas"]["dtos.PlanPeriod"];
        };
        "dtos.PlanLimit": {
            limit: number;
            model: components["schemas"]["dtos.PlanModel"];
            overagePriceCents: number;
            resource: components["schemas"]["dtos.PlanResource"];
        };
        /** @enum {string} */
        "dtos.PlanModel": "fixed" | "metered";
        /** @enum {string} */
        "dtos.PlanPeriod": "monthly" | "yearly";
        /** @enum {string} */
        "dtos.PlanResource": "inspection" | "template" | "user";
        /** @enum {string} */
        "enums.Currency": "ARS" | "UYU" | "CHL" | "USD";
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
type ReadonlyArray<T> = [
    Exclude<T, undefined>
] extends [
    any[]
] ? Readonly<Exclude<T, undefined>> : Readonly<Exclude<T, undefined>[]>;
export const dtosPlanModelValues: ReadonlyArray<components["schemas"]["dtos.PlanModel"]> = ["fixed", "metered"];
export const dtosPlanPeriodValues: ReadonlyArray<components["schemas"]["dtos.PlanPeriod"]> = ["monthly", "yearly"];
export const dtosPlanResourceValues: ReadonlyArray<components["schemas"]["dtos.PlanResource"]> = ["inspection", "template", "user"];
export const enumsCurrencyValues: ReadonlyArray<components["schemas"]["enums.Currency"]> = ["ARS", "UYU", "CHL", "USD"];
export type operations = Record<string, never>;
